export default "__VITE_ASSET__DliYbOt3__"